const LOCALES = {
    pt_pt: "pt",
    es_es: "es",
};

export { LOCALES };
